import React, { useState, useEffect } from 'react';
import {
  IconButton,
  Badge,
  Menu,
  Typography,
  MenuItem,
  Avatar,
  Box,
  Chip,
  Button,
  ListItemText,
  ListItemAvatar,
  LinearProgress,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MessageIcon from '@mui/icons-material/Message';
import TaskIcon from '@mui/icons-material/Task';
import GroupIcon from '@mui/icons-material/Group';
import HelpIcon from '@mui/icons-material/Help';
import DeleteIcon from '@mui/icons-material/Delete';
import ForumIcon from '@mui/icons-material/Forum';
import EventIcon from '@mui/icons-material/Event';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { getSocket } from '../socket/socket';
import { formatDistanceToNow } from 'date-fns';
import { useNavigate } from "react-router-dom";
const VENDOR_PROGRESS_STORAGE_KEY = 'vendorProgressNotice';
const VENDOR_PROGRESS_TTL_MS = 24 * 60 * 60 * 1000;

const UniversalNotifications = () => {
  console.log("universnotficationuniversnotficationuniversnotficationuniversnotficationuniversnotfication")
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [vendorProgressNotice, setVendorProgressNotice] = useState(null);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  

useEffect(()=>{

console.log(notifications,"form univerdsl ntfication unfiversal ntication")

},[notifications])
  useEffect(() => {
    const socket = getSocket();
    if (!socket || !user?.id) return;

    // Request notifications from server
    socket.emit('get-notification', { userId: user.id });

    // Listen for notifications from server
    socket.on('receive-notifications', (data) => {
      console.log('📩 Received notifications:', data);
      const list = data || [];
      setNotifications(list);
      setUnreadCount(list.filter((notif) => !notif.isRead).length || 0);
    });

    // Listen for new notifications in real-time
    socket.on('new-notification', (data) => {
      console.log('📨 New notification received:', data);
      setNotifications((prev) => [data, ...prev]);
      setUnreadCount((prev) => prev + 1);
    });

    // Listen for notification deletion
    socket.on('notification-deleted', () => {
      // Refresh notifications after deletion
      socket.emit('get-notification', { userId: user.id });
    });

    // Listen for notification marked as read
    socket.on('notification-marked-read', ({ success, notificationId }) => {
      if (success) {
        console.log('✅ Notification marked as read:', notificationId);
      }
    });

    return () => {
      socket.off('receive-notifications');
      socket.off('new-notification');
      socket.off('notification-deleted');
      socket.off('notification-marked-read');
    };
  }, [user?.id]);

  useEffect(() => {
    const stored = localStorage.getItem(VENDOR_PROGRESS_STORAGE_KEY);
    if (!stored) return;
    try {
      const parsed = JSON.parse(stored);
      if (!parsed || !parsed.updatedAt) {
        localStorage.removeItem(VENDOR_PROGRESS_STORAGE_KEY);
        return;
      }
      const age = Date.now() - parsed.updatedAt;
      if (age >= VENDOR_PROGRESS_TTL_MS) {
        localStorage.removeItem(VENDOR_PROGRESS_STORAGE_KEY);
        return;
      }
      setVendorProgressNotice(parsed);
    } catch (error) {
      localStorage.removeItem(VENDOR_PROGRESS_STORAGE_KEY);
    }
  }, []);

  useEffect(() => {
    const handleVendorProgress = (event) => {
      const detail = event?.detail || {};
      if (!detail.vendorName) return;
      setVendorProgressNotice((prev) => {
        const next = {
        ...prev,
        ...detail,
        updatedAt: detail.updatedAt || Date.now(),
        };
        localStorage.setItem(VENDOR_PROGRESS_STORAGE_KEY, JSON.stringify(next));
        return next;
      });
    };

    window.addEventListener('vendor-progress', handleVendorProgress);
    return () => {
      window.removeEventListener('vendor-progress', handleVendorProgress);
    };
  }, []);

  useEffect(() => {
    if (!vendorProgressNotice) return undefined;
    const updatedAt = Number(vendorProgressNotice.updatedAt) || Date.now();
    const age = Date.now() - updatedAt;
    if (age >= VENDOR_PROGRESS_TTL_MS) {
      localStorage.removeItem(VENDOR_PROGRESS_STORAGE_KEY);
      setVendorProgressNotice(null);
      return undefined;
    }
    if (vendorProgressNotice.stage !== 'completed' && vendorProgressNotice.stage !== 'error') {
      return undefined;
    }
    const remainingMs = Math.max(0, VENDOR_PROGRESS_TTL_MS - age);
    const timer = setTimeout(() => {
      localStorage.removeItem(VENDOR_PROGRESS_STORAGE_KEY);
      setVendorProgressNotice(null);
    }, remainingMs);
    return () => clearTimeout(timer);
  }, [vendorProgressNotice]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getNotificationIcon = (type) => {
    const iconStyle = { fontSize: 20 };
    switch (type) {
      case 'message':
        return <MessageIcon sx={{ ...iconStyle, color: '#1976d2' }} />;
      case 'task':
        return <TaskIcon sx={{ ...iconStyle, color: '#388e3c' }} />;
      case 'groupMessage':
        return <GroupIcon sx={{ ...iconStyle, color: '#f57c00' }} />;
      case 'thread':
        return <ForumIcon sx={{ ...iconStyle, color: '#9c27b0' }} />;
      case 'meeting':
        return <EventIcon sx={{ ...iconStyle, color: '#2196f3' }} />;
      case 'helpticket':
      case 'helpTicket':
        return <HelpIcon sx={{ ...iconStyle, color: '#ff5722' }} />;
      case 'comment':
        return <MessageIcon sx={{ ...iconStyle, color: '#7b1fa2' }} />;
      case 'vendorProgress':
        return <TaskIcon sx={{ ...iconStyle, color: '#1976d2' }} />;
      case 'system':
        return <HelpIcon sx={{ ...iconStyle, color: '#d32f2f' }} />;
      default:
        return <NotificationsIcon sx={{ ...iconStyle, color: '#757575' }} />;
    }
  };

  const markAsRead = (notificationId) => {
    const socket = getSocket();
    if (!socket) return;

    socket.emit('mark-notification-read', { notificationId });

    setNotifications((prev) =>
      prev.map((notif) =>
        notif._id === notificationId ? { ...notif, isRead: true } : notif
      )
    );
    setUnreadCount((prev) => Math.max(0, prev - 1));
  };

  const deleteNotification = (notificationId) => {
    const socket = getSocket();
    if (!socket) return;

    socket.emit('delete-notification', { notificationId });
  };

  const markAllAsRead = () => {
    const socket = getSocket();
    if (!socket) return;

    const unreadNotifications = notifications.filter((notif) => !notif.isRead);
    unreadNotifications.forEach((notif) => {
      socket.emit('mark-notification-read', { notificationId: notif._id });
    });

    setNotifications((prev) =>
      prev.map((notif) => ({ ...notif, isRead: true }))
    );
    setUnreadCount(0);
  };

  const clearAllNotifications = () => {
    const socket = getSocket();
    if (socket) {
      notifications.forEach((notif) => {
        if (notif?._id) {
          socket.emit('delete-notification', { notificationId: notif._id });
        }
      });
    }
    setNotifications([]);
    setUnreadCount(0);
    clearVendorProgressNotice();
  };

  const clearVendorProgressNotice = () => {
    localStorage.removeItem(VENDOR_PROGRESS_STORAGE_KEY);
    setVendorProgressNotice(null);
  };

  const formatTime = (timestamp) => {
    try {
      return formatDistanceToNow(new Date(timestamp), { addSuffix: true });
    } catch (error) {
      return 'Recently';
    }
  };

  const formatDuration = (ms) => {
    if (!Number.isFinite(ms)) return 'Calculating...';
    const totalSeconds = Math.max(0, Math.round(ms / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;
  };

  const formatRate = (percent, elapsedMs) => {
    const pct = Number(percent);
    const elapsed = Number(elapsedMs);
    if (!Number.isFinite(pct) || !Number.isFinite(elapsed) || pct <= 0 || elapsed <= 0) {
      return 'Calculating...';
    }
    const minutes = elapsed / 60000;
    if (minutes <= 0) return 'Calculating...';
    const rate = pct / minutes;
    return `${rate.toFixed(1)}%/min`;
  };

  const progressNotification = vendorProgressNotice
    ? {
      _id: 'vendor-progress',
      isLocal: true,
      isRead: true,
      type: 'vendorProgress',
      title:
        vendorProgressNotice.mode === 'edit' ? 'Updating Vendor' : 'Adding Vendor',
      message: vendorProgressNotice.vendorName || 'Vendor',
      createdAt: vendorProgressNotice.updatedAt || Date.now(),
      metadata: { ...vendorProgressNotice },
    }
    : null;

  const displayNotifications = progressNotification
    ? [progressNotification, ...notifications]
    : notifications;

  const NotificationItem = ({ notification }) => {
    console.log("NotificationItemNotificationItemNotificationItemNotificationItemNotificationItemNotificationItem",notification)
    const isLocal = !!notification.isLocal;
    const isVendorProgress = notification.type === 'vendorProgress';
    const progress = notification.metadata || {};
    const percent = Math.round(Number(progress.percent) || 0);
    const progressValue = Math.min(100, Math.max(0, percent));

    return (
    <MenuItem
      key={notification._id}
      onClick={() => {
        if (!isLocal && !notification.isRead) {
          markAsRead(notification._id);

        }
        if (notification.type==="message") {
                 navigate("/chatapp", { state: { jumpToId:notification } });
        }else if(notification.type =="task"){
                navigate("/maintask", { state: { Task:notification } });
               
        }else{
          console.log(notification.type)
        }
      }}
      sx={{
        width: '100%',
        maxWidth: 400,
        minHeight: 70,
        padding: 2,
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: notification.isRead ? 'transparent' : '#f8f9ff',
        '&:hover': {
          backgroundColor: '#f5f5f5',
        },
      }}
    >
      <ListItemAvatar>
        <Avatar sx={{ width: 40, height: 40, backgroundColor: '#fff' }}>
          {getNotificationIcon(notification.type)}
        </Avatar>
      </ListItemAvatar>

      <ListItemText
        disableTypography
        primary={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <Typography
              variant="body2"
              component="span"
              sx={{
                fontWeight: notification.isRead ? 'normal' : 'bold',
                fontSize: '14px',
                flex: 1,
              }}
            >
              {notification.title}
            </Typography>
            {isVendorProgress ? (
              <IconButton
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  clearVendorProgressNotice();
                }}
                sx={{ ml: 1 }}
                aria-label="clear vendor progress"
              >
                <CloseIcon sx={{ fontSize: 16 }} />
              </IconButton>
            ) : !notification.isRead && (
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: '#1976d2',
                  ml: 1,
                }}
              />
            )}
          </Box>
        }
        secondary={
          <Box>
            {isVendorProgress ? (
              <Box sx={{ mt: 0.5 }}>
                <Typography variant="body2" sx={{ fontSize: '13px', mb: 0.5 }}>
                  Vendor: {progress.vendorName || notification.message}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <LinearProgress variant="determinate" value={progressValue} />
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    {progressValue}%
                  </Typography>
                </Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  Stage: {progress.stage || 'starting'} | Rate: {formatRate(progress.percent, progress.elapsedMs)}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  ETA: {formatDuration(progress.etaMs)}
                </Typography>
                {progress.total > 0 && (
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                    Completed: {progress.completed}/{progress.total}
                  </Typography>
                )}
                {progress.errorMessage && (
                  <Typography variant="caption" color="error" sx={{ display: 'block' }}>
                    {progress.errorMessage}
                  </Typography>
                )}
              </Box>
            ) : (
            <Typography
              variant="body2"
              component="span"
              color="text.secondary"
              sx={{
                fontSize: '16px',
                mt: 0.5,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {notification.type === 'groupMessage' &&
                notification.metadata?.sender && (
                  <span
                    style={{
                      fontWeight: 'bold',
                      color: '#1976d2',
                      marginRight: 4,
                    }}
                  >
                    {notification.metadata.sender.firstName}{' '}
                    {notification.metadata.sender.lastName}:
                  </span>
                )}

              {notification.type === 'thread' &&
                notification.metadata?.threadId && (
                  <span
                    style={{
                      fontStyle: 'italic',
                      color: '#9c27b0',
                      fontSize: '12px',
                      marginRight: 4,
                    }}
                  >
                    Thread •
                  </span>
                )}

              {notification.type === 'meeting' &&
                notification.metadata?.startDate && (
                  <span
                    style={{
                      fontStyle: 'italic',
                      color: '#2196f3',
                      fontSize: '12px',
                      marginRight: 4,
                    }}
                  >
                    📅{' '}
                    {new Date(
                      notification.metadata.startDate
                    ).toLocaleDateString("en-GB")}{' '}
                    •
                  </span>
                )}
                    {notification.type === 'meeting' &&
                notification.metadata?.startDate && (
                  <span
                    style={{
                      fontStyle: 'italic',
                      color: '#2196f3',
                      fontSize: '12px',
                      marginRight: 4,
                    }}
                  >
                    📅{' '}
                    {new Date(
                      notification.metadata.startDate
                    ).toLocaleDateString("en-GB")}{' '}
                    •
                  </span>
                )}
                
                 {notification.type === 'message' &&
                notification.metadata?.message_id && (
                  <span
                    style={{
                      fontStyle: 'italic',
                      color: '#2196f3',
                      fontSize: '12px',
                      marginRight: 4,
                    }}
                  >
                    {notification.metadata.user.firstName}{' '}
                    {notification.metadata.user.lastName}:
                    📅{' '}
                    {/* {new Date(
                      notification.metadata.startDate
                    ).toLocaleDateString("en-GB")}{' '}
                    • */}
                  </span>
                )}


              {' '}{notification.message}
            </Typography>
            )}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mt: 1,
              }}
            >
              <Chip
                label={isVendorProgress ? 'vendor progress' : notification.type}
                size="small"
                sx={{
                  fontSize: '10px',
                  height: 18,
                  textTransform: 'capitalize',
                }}
              />
              <Typography
                variant="caption"
                component="span"
                color="text.secondary"
                sx={{ fontSize: '11px' }}
              >
                {formatTime(notification.createdAt)}
              </Typography>
            </Box>
          </Box>
        }
      />

      {!isLocal && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            deleteNotification(notification._id);
          }}
          size="small"
          sx={{ ml: 1 }}
        >
          <DeleteIcon sx={{ fontSize: 16 }} />
        </IconButton>
      )}
    </MenuItem>
    );
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: 420,
            maxHeight: 500,
            mt: 1,
            border: '1px solid #e0e0e0',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            borderRadius: 2,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {/* Header */}
        <Box sx={{ px: 3, py: 2, borderBottom: '1px solid #f0f0f0' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '18px' }}>
              Notifications
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {unreadCount > 0 && (
                <Button
                  size="small"
                  onClick={markAllAsRead}
                  sx={{
                    textTransform: 'none',
                    fontSize: '12px',
                    color: '#1976d2',
                  }}
                >
                  Mark all as read
                </Button>
              )}
              {displayNotifications.length > 0 && (
                <Button
                  size="small"
                  onClick={clearAllNotifications}
                  sx={{
                    textTransform: 'none',
                    fontSize: '12px',
                    color: '#d32f2f',
                  }}
                >
                  Clear all
                </Button>
              )}
            </Box>
          </Box>
          {unreadCount > 0 && (
            <Typography variant="caption" color="text.secondary">
              {unreadCount} unread notification{unreadCount > 1 ? 's' : ''}
            </Typography>
          )}
        </Box>

        {/* Notifications List */}
        <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
          {displayNotifications.length === 0 ? (
            <MenuItem disabled sx={{ py: 3, justifyContent: 'center' }}>
              <Box sx={{ textAlign: 'center' }}>
                <NotificationsIcon sx={{ fontSize: 48, color: '#ccc', mb: 1 }} />
                <Typography variant="body2" color="text.secondary">
                  No notifications yet
                </Typography>
              </Box>
            </MenuItem>
          ) : (
            displayNotifications
              .slice()
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .map((notification) => (
                <NotificationItem
                  key={notification._id}
                  notification={notification}
                />
              ))
          )}
        </Box>

        {/* Footer */}
        {displayNotifications.length > 0 && (
          <Box sx={{ borderTop: '1px solid #f0f0f0', px: 3, py: 2 }}>
            <Button
              fullWidth
              variant="text"
              size="small"
              onClick={() => {
                handleClose();
                // navigate to notifications page if needed
              }}
              sx={{
                textTransform: 'none',
                color: '#1976d2',
                fontSize: '13px',
              }}
            >
              See all notifications
            </Button>
          </Box>
        )}
      </Menu>
    </>
  );
};

export default UniversalNotifications;
